<ng-container *transloco="let t; read: 'orders'">
    <div class="componentContainer">
        <section class="xs12col componentHeader">
            <h1>{{t('client.title')}}</h1>
        </section>

        <section class="oneCol">
            <div class="xs12col">
                <div class="boxContainer">
                    <div class="box">
                        <app-order-grid
                        [orders]="orders"
                        (onReload)="onReload($event)">
                    </app-order-grid>
                    </div>
                </div>
            </div>
        </section>
    </div>
</ng-container>